import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import { makeStyles } from '@material-ui/core/styles';

export type ActionButtonsClasses = 'container' | 'item' | 'itemLabel' | 'saveButton' | 'enquireButton';

const actionButtonsStyles = makeStyles<ISpcTheme, ActionButtonsClasses>(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-start',

      [theme.breakpoints.down('md')]: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    item: {
      padding: '0 8px',

      [theme.breakpoints.down('md')]: {
        padding: '8px 0',
      },
    },
    itemLabel: {},
    saveButton: {},
    enquireButton: {},
  }),
  { name: 'Customise_ActionButtons' },
);

export default actionButtonsStyles;
